import { t } from 'i18n'

export const COUNTRIES = [
  { code: 'AF', name: t('countries.AF') },
  { code: 'AX', name: t('countries.AX') },
  { code: 'AL', name: t('countries.AL') },
  { code: 'DZ', name: t('countries.DZ') },
  { code: 'AS', name: t('countries.AS') },
  { code: 'AD', name: t('countries.AD') },
  { code: 'AO', name: t('countries.AO') },
  { code: 'AI', name: t('countries.AI') },
  { code: 'AQ', name: t('countries.AQ') },
  { code: 'AG', name: t('countries.AG') },
  { code: 'AR', name: t('countries.AR') },
  { code: 'AM', name: t('countries.AM') },
  { code: 'AW', name: t('countries.AW') },
  { code: 'AU', name: t('countries.AU') },
  { code: 'AT', name: t('countries.AT') },
  { code: 'AZ', name: t('countries.AZ') },
  { code: 'BS', name: t('countries.BS') },
  { code: 'BH', name: t('countries.BH') },
  { code: 'BD', name: t('countries.BD') },
  { code: 'BB', name: t('countries.BB') },
  { code: 'BY', name: t('countries.BY') },
  { code: 'BE', name: t('countries.BE') },
  { code: 'BZ', name: t('countries.BZ') },
  { code: 'BJ', name: t('countries.BJ') },
  { code: 'BM', name: t('countries.BM') },
  { code: 'BT', name: t('countries.BT') },
  { code: 'BO', name: t('countries.BO') },
  { code: 'BA', name: t('countries.BA') },
  { code: 'BW', name: t('countries.BW') },
  { code: 'BV', name: t('countries.BV') },
  { code: 'BR', name: t('countries.BR') },
  { code: 'IO', name: t('countries.IO') },
  { code: 'VG', name: t('countries.VG') },
  { code: 'BN', name: t('countries.BN') },
  { code: 'BG', name: t('countries.BG') },
  { code: 'BF', name: t('countries.BF') },
  { code: 'BI', name: t('countries.BI') },
  { code: 'KH', name: t('countries.KH') },
  { code: 'CM', name: t('countries.CM') },
  { code: 'CA', name: t('countries.CA') },
  { code: 'CV', name: t('countries.CV') },
  { code: 'BQ', name: t('countries.BQ') },
  { code: 'KY', name: t('countries.KY') },
  { code: 'CF', name: t('countries.CF') },
  { code: 'TD', name: t('countries.TD') },
  { code: 'CL', name: t('countries.CL') },
  { code: 'CN', name: t('countries.CN') },
  { code: 'CX', name: t('countries.CX') },
  { code: 'CC', name: t('countries.CC') },
  { code: 'CO', name: t('countries.CO') },
  { code: 'KM', name: t('countries.KM') },
  { code: 'CG', name: t('countries.CG') },
  { code: 'CD', name: t('countries.CD') },
  { code: 'CK', name: t('countries.CK') },
  { code: 'CR', name: t('countries.CR') },
  { code: 'CI', name: t('countries.CI') },
  { code: 'HR', name: t('countries.HR') },
  { code: 'CU', name: t('countries.CU') },
  { code: 'CW', name: t('countries.CW') },
  { code: 'CY', name: t('countries.CY') },
  { code: 'CZ', name: t('countries.CZ') },
  { code: 'DK', name: t('countries.DK') },
  { code: 'DJ', name: t('countries.DJ') },
  { code: 'DM', name: t('countries.DM') },
  { code: 'DO', name: t('countries.DO') },
  { code: 'EC', name: t('countries.EC') },
  { code: 'EG', name: t('countries.EG') },
  { code: 'SV', name: t('countries.SV') },
  { code: 'GQ', name: t('countries.GQ') },
  { code: 'ER', name: t('countries.ER') },
  { code: 'EE', name: t('countries.EE') },
  { code: 'SZ', name: t('countries.SZ') },
  { code: 'ET', name: t('countries.ET') },
  { code: 'FK', name: t('countries.FK') },
  { code: 'FO', name: t('countries.FO') },
  { code: 'FJ', name: t('countries.FJ') },
  { code: 'FI', name: t('countries.FI') },
  { code: 'FR', name: t('countries.FR') },
  { code: 'GF', name: t('countries.GF') },
  { code: 'PF', name: t('countries.PF') },
  { code: 'TF', name: t('countries.TF') },
  { code: 'GA', name: t('countries.GA') },
  { code: 'GM', name: t('countries.GM') },
  { code: 'GE', name: t('countries.GE') },
  { code: 'DE', name: t('countries.DE') },
  { code: 'GH', name: t('countries.GH') },
  { code: 'GI', name: t('countries.GI') },
  { code: 'GR', name: t('countries.GR') },
  { code: 'GL', name: t('countries.GL') },
  { code: 'GD', name: t('countries.GD') },
  { code: 'GP', name: t('countries.GP') },
  { code: 'GU', name: t('countries.GU') },
  { code: 'GT', name: t('countries.GT') },
  { code: 'GG', name: t('countries.GG') },
  { code: 'GN', name: t('countries.GN') },
  { code: 'GW', name: t('countries.GW') },
  { code: 'GY', name: t('countries.GY') },
  { code: 'HT', name: t('countries.HT') },
  { code: 'HM', name: t('countries.HM') },
  { code: 'HN', name: t('countries.HN') },
  { code: 'HK', name: t('countries.HK') },
  { code: 'HU', name: t('countries.HU') },
  { code: 'IS', name: t('countries.IS') },
  { code: 'IN', name: t('countries.IN') },
  { code: 'ID', name: t('countries.ID') },
  { code: 'IR', name: t('countries.IR') },
  { code: 'IQ', name: t('countries.IQ') },
  { code: 'IE', name: t('countries.IE') },
  { code: 'IM', name: t('countries.IM') },
  { code: 'IL', name: t('countries.IL') },
  { code: 'IT', name: t('countries.IT') },
  { code: 'JM', name: t('countries.JM') },
  { code: 'JP', name: t('countries.JP') },
  { code: 'JE', name: t('countries.JE') },
  { code: 'JO', name: t('countries.JO') },
  { code: 'KZ', name: t('countries.KZ') },
  { code: 'KE', name: t('countries.KE') },
  { code: 'KI', name: t('countries.KI') },
  { code: 'KW', name: t('countries.KW') },
  { code: 'KG', name: t('countries.KG') },
  { code: 'LA', name: t('countries.LA') },
  { code: 'LV', name: t('countries.LV') },
  { code: 'LB', name: t('countries.LB') },
  { code: 'LS', name: t('countries.LS') },
  { code: 'LR', name: t('countries.LR') },
  { code: 'LY', name: t('countries.LY') },
  { code: 'LI', name: t('countries.LI') },
  { code: 'LT', name: t('countries.LT') },
  { code: 'LU', name: t('countries.LU') },
  { code: 'MO', name: t('countries.MO') },
  { code: 'MG', name: t('countries.MG') },
  { code: 'MW', name: t('countries.MW') },
  { code: 'MY', name: t('countries.MY') },
  { code: 'MV', name: t('countries.MV') },
  { code: 'ML', name: t('countries.ML') },
  { code: 'MT', name: t('countries.MT') },
  { code: 'MH', name: t('countries.MH') },
  { code: 'MQ', name: t('countries.MQ') },
  { code: 'MR', name: t('countries.MR') },
  { code: 'MU', name: t('countries.MU') },
  { code: 'YT', name: t('countries.YT') },
  { code: 'MX', name: t('countries.MX') },
  { code: 'FM', name: t('countries.FM') },
  { code: 'MD', name: t('countries.MD') },
  { code: 'MC', name: t('countries.MC') },
  { code: 'MN', name: t('countries.MN') },
  { code: 'ME', name: t('countries.ME') },
  { code: 'MS', name: t('countries.MS') },
  { code: 'MA', name: t('countries.MA') },
  { code: 'MZ', name: t('countries.MZ') },
  { code: 'MM', name: t('countries.MM') },
  { code: 'NA', name: t('countries.NA') },
  { code: 'NR', name: t('countries.NR') },
  { code: 'NP', name: t('countries.NP') },
  { code: 'NL', name: t('countries.NL') },
  { code: 'NC', name: t('countries.NC') },
  { code: 'NZ', name: t('countries.NZ') },
  { code: 'NI', name: t('countries.NI') },
  { code: 'NE', name: t('countries.NE') },
  { code: 'NG', name: t('countries.NG') },
  { code: 'NU', name: t('countries.NU') },
  { code: 'NF', name: t('countries.NF') },
  { code: 'KP', name: t('countries.KP') },
  { code: 'MK', name: t('countries.MK') },
  { code: 'MP', name: t('countries.MP') },
  { code: 'NO', name: t('countries.NO') },
  { code: 'OM', name: t('countries.OM') },
  { code: 'PK', name: t('countries.PK') },
  { code: 'PW', name: t('countries.PW') },
  { code: 'PS', name: t('countries.PS') },
  { code: 'PA', name: t('countries.PA') },
  { code: 'PG', name: t('countries.PG') },
  { code: 'PY', name: t('countries.PY') },
  { code: 'PE', name: t('countries.PE') },
  { code: 'PH', name: t('countries.PH') },
  { code: 'PN', name: t('countries.PN') },
  { code: 'PL', name: t('countries.PL') },
  { code: 'PT', name: t('countries.PT') },
  { code: 'PR', name: t('countries.PR') },
  { code: 'QA', name: t('countries.QA') },
  { code: 'RE', name: t('countries.RE') },
  { code: 'RO', name: t('countries.RO') },
  { code: 'RU', name: t('countries.RU') },
  { code: 'RW', name: t('countries.RW') },
  { code: 'WS', name: t('countries.WS') },
  { code: 'SM', name: t('countries.SM') },
  { code: 'ST', name: t('countries.ST') },
  { code: 'SA', name: t('countries.SA') },
  { code: 'SN', name: t('countries.SN') },
  { code: 'RS', name: t('countries.RS') },
  { code: 'SC', name: t('countries.SC') },
  { code: 'SL', name: t('countries.SL') },
  { code: 'SG', name: t('countries.SG') },
  { code: 'SX', name: t('countries.SX') },
  { code: 'SK', name: t('countries.SK') },
  { code: 'SI', name: t('countries.SI') },
  { code: 'SB', name: t('countries.SB') },
  { code: 'SO', name: t('countries.SO') },
  { code: 'ZA', name: t('countries.ZA') },
  { code: 'GS', name: t('countries.GS') },
  { code: 'KR', name: t('countries.KR') },
  { code: 'SS', name: t('countries.SS') },
  { code: 'ES', name: t('countries.ES') },
  { code: 'LK', name: t('countries.LK') },
  { code: 'BL', name: t('countries.BL') },
  { code: 'SH', name: t('countries.SH') },
  { code: 'KN', name: t('countries.KN') },
  { code: 'LC', name: t('countries.LC') },
  { code: 'MF', name: t('countries.MF') },
  { code: 'PM', name: t('countries.PM') },
  { code: 'VC', name: t('countries.VC') },
  { code: 'SD', name: t('countries.SD') },
  { code: 'SR', name: t('countries.SR') },
  { code: 'SJ', name: t('countries.SJ') },
  { code: 'SE', name: t('countries.SE') },
  { code: 'CH', name: t('countries.CH') },
  { code: 'SY', name: t('countries.SY') },
  { code: 'TW', name: t('countries.TW') },
  { code: 'TJ', name: t('countries.TJ') },
  { code: 'TZ', name: t('countries.TZ') },
  { code: 'TH', name: t('countries.TH') },
  { code: 'TL', name: t('countries.TL') },
  { code: 'TG', name: t('countries.TG') },
  { code: 'TK', name: t('countries.TK') },
  { code: 'TO', name: t('countries.TO') },
  { code: 'TT', name: t('countries.TT') },
  { code: 'TN', name: t('countries.TN') },
  { code: 'TR', name: t('countries.TR') },
  { code: 'TM', name: t('countries.TM') },
  { code: 'TC', name: t('countries.TC') },
  { code: 'TV', name: t('countries.TV') },
  { code: 'UM', name: t('countries.UM') },
  { code: 'VI', name: t('countries.VI') },
  { code: 'UG', name: t('countries.UG') },
  { code: 'UA', name: t('countries.UA') },
  { code: 'AE', name: t('countries.AE') },
  { code: 'GB', name: t('countries.GB') },
  { code: 'US', name: t('countries.US') },
  { code: 'UY', name: t('countries.UY') },
  { code: 'UZ', name: t('countries.UZ') },
  { code: 'VU', name: t('countries.VU') },
  { code: 'VA', name: t('countries.VA') },
  { code: 'VE', name: t('countries.VE') },
  { code: 'VN', name: t('countries.VN') },
  { code: 'WF', name: t('countries.WF') },
  { code: 'EH', name: t('countries.EH') },
  { code: 'YE', name: t('countries.YE') },
  { code: 'ZM', name: t('countries.ZM') },
  { code: 'ZW', name: t('countries.ZW') }
]
